export function exists<T>(condition: T | undefined | null): condition is T {
  return condition !== undefined && condition !== null
}

export function assertExists<T>(
  condition: T | undefined | null,
  message: string
): asserts condition is T {
  if (!exists(condition)) {
    throw new Error(message)
  }
}
